import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	return {
		gamePartners: data.data,
		pagesTotal: data.meta.total,
	};
};

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	page: data.page,
	per_page: data.perPage || 10,
});
